import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-operation-theater',
  templateUrl: './operation-theater.component.html',
  styleUrls: []
})
export class OperationTheaterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/operation-theater.component.ts